module.exports = __webpack_public_path__ + "media/ruoyi_05_世界绕着转.0ece633e.wav";